import { useContext, useEffect } from 'react';
import { MainLayoutContext } from '../../Dash.router';

export default function useBusinessesCommon() {
  const { addMainClassName, resetMainClassName } =
    useContext(MainLayoutContext);

  useEffect(() => {
    addMainClassName('businesses-common-main-layout');

    return () => {
      resetMainClassName();
    };
  }, [addMainClassName, resetMainClassName]);
}
